import LockIcon from '@assets/icons/lock.svg';
import React, { useMemo } from 'react';
import ShieldIcon from '@assets/icons/shield.svg';
import { ActivityIndicator } from 'react-native';
import { KeyboardShortcutBadge } from '@/experiences/sales-portal/components/keyboard-shortcut-badge';
import { PriceValidationIcon } from '@/domain/pricing/components/price-validation-icon';
import { SalesPortalShortcuts } from '@/experiences/sales-portal/platform/shortcuts/sales-portal-shortcuts';
import { Theme } from '@/contexts/theme-context';

const ICON_SIZE = 12;

interface UsePricingCellIconParams {
  activeValidationMessage: string | null;
  disabled: boolean;
  isCellFocused: boolean;
  isPeakPriceProtected: boolean;
  isSaving: boolean;
  quickActionsLength: number;
  theme: Theme;
}

export function usePricingCellIcon({
  activeValidationMessage,
  disabled,
  isCellFocused,
  isPeakPriceProtected,
  isSaving,
  quickActionsLength,
  theme,
}: UsePricingCellIconParams): React.ReactNode {
  return useMemo(() => {
    if (isSaving) {
      return (
        <ActivityIndicator
          color={theme.sk.color.text.disabled}
          size={ICON_SIZE}
        />
      );
    }
    if (disabled) {
      return isPeakPriceProtected ? (
        <ShieldIcon
          height={ICON_SIZE}
          stroke={theme.sk.color.text.disabled}
          width={ICON_SIZE}
        />
      ) : (
        <LockIcon
          height={ICON_SIZE}
          stroke={theme.sk.color.text.disabled}
          width={ICON_SIZE}
        />
      );
    }
    if (activeValidationMessage) {
      return <PriceValidationIcon message={activeValidationMessage} />;
    }
    if (isCellFocused && quickActionsLength > 0) {
      return (
        <KeyboardShortcutBadge shortcut={SalesPortalShortcuts.QuickActions} />
      );
    }
    return null;
  }, [
    activeValidationMessage,
    disabled,
    isCellFocused,
    isPeakPriceProtected,
    isSaving,
    quickActionsLength,
    theme,
  ]);
}
